import { render } from "./OtherSolutionPage.vue?vue&type=template&id=1f104a90"
import script from "./OtherSolutionPage.vue?vue&type=script&lang=js"
export * from "./OtherSolutionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__